<template>
    <v-btn class="kp-btn-secondary" v-bind="$attrs" color="primary" text depressed small v-on="$listeners">
        <slot></slot>
    </v-btn>
</template>

<script>
export default {
    name: 'SecondaryBtn',
};
</script>

<style lang="scss" scoped></style>
